  document.getElementById('viewCertificateBtn')?.addEventListener('click', function () {
     const userId = document.getElementById("customer-data").getAttribute("data-customer-id");
    // API endpoint
    const apiUrl = 'https://prod-srp.ultiwebtechnologies.com/api/generate-shopify-certificate';

    // API request payload
    const requestData = {
      shopify_user_id: userId, // Replace with dynamic value if needed
    };

    // Make API call
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/pdf', // Specify that we expect a PDF response
      },
      body: JSON.stringify(requestData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        console.log(response);
        return response.blob(); // Get the response as a blob
      })
      .then(blob => {
        // Create a URL for the blob
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'certificate.pdf'; 
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.log(error);
        console.error('There was a problem with the fetch operation:', error);
        alert('Oops! It looks like you don’t have a certificate yet. Don’t worry! Purchase a product to unlock your certificate and become a proud Planet Warrior!');
      });
  });